import axios from 'axios';
import { auth } from './auth';
import { blockchain } from './blockchain';
import { autocomplete } from './autocomplete';
import { entity } from './entity';

export const DefaultTxLimit = 10;
export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URI,
});

export const setToken = (token: string | null) => {
  if (!token) {
    delete axiosInstance.defaults.headers.common['Authorization'];
    return;
  }
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export const api = {
  auth,
  autocomplete,
  blockchain,
  entity,
};
